/**
 * Varje delsystem är tilldelat ett block av tusen id siffror
 */
export const DelsystemIdInterval: { [interval: number]: string } = {
  0: 'GA',
  1: 'BO',
  2: 'EK',
  3: 'AR',
  4: 'OF',
  5: 'KJ',
  6: 'KR',
  7: 'SYS',
  8: 'OP',
  9: 'LA',
  10: 'LR',
  11: 'MU',
  12: 'PU',
  13: 'DI',
  14: 'TI',
  15: 'WEK',
  16: 'WBO',
  17: 'WLR',
  18: 'WTI',
  19: 'BJ',
  20: 'WBJ',
  21: 'WGA',
  22: 'WOF',
  23: 'WDI',
  24: 'WAR',
};
